module.exports = __webpack_public_path__ + "img/demo-millenium_biltmore.3c3c458e.jpg";